module.exports = __webpack_public_path__ + "static/img/rotate02.cee472c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate02.png
// module id = YnOu
// module chunks = 1